export default function megaMenu() {
  const MENUS = document.querySelectorAll('.mtt-mega-menu')

  if (MENUS.length > 0) {
    for (let i = 0; i < MENUS.length; i++) {
      const MENU = MENUS[i]

      addHoverEffect(MENU)
    }
  }

  function addHoverEffect(MENU) {
    const LINKS = MENU.querySelectorAll('.has-sublinks [data-id]')

    if (LINKS.length > 0) {
      for (let i = 0; i < LINKS.length; i++) {
        const LINK = LINKS[i]
        const BREAKPOINT = 1160

        LINK.addEventListener('mouseover', () => {
          const DATA_ID = LINK.getAttribute('data-id')

          if (window.innerWidth <= BREAKPOINT) {
            return
          }

          if (DATA_ID) {
            const SUBLINK_WRAPPER = MENU.querySelector(`.mtt-mega-menu__sublinks-wrapper[data-id="${DATA_ID}"]`)
            const ACTIVE_SUBLINK_WRAPPER = MENU.querySelector('.mtt-mega-menu__sublinks-wrapper.active')

            if (!ACTIVE_SUBLINK_WRAPPER) {
              return
            }

            if (!SUBLINK_WRAPPER) {
              return
            }

            if  (DATA_ID === ACTIVE_SUBLINK_WRAPPER.getAttribute('data-id')) {
              return
            }

            ACTIVE_SUBLINK_WRAPPER.classList.remove('active')
            SUBLINK_WRAPPER.classList.add('active')
          }
        })
      }
    }
  }
}